// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-sale-notice-cell[data-v-d6756512]{display:flex;align-items:center}.notice-text[data-v-d6756512]{color:var(--warning);margin-right:.5rem;font-size:1.2rem}`, "",{"version":3,"sources":["webpack://./client/components/TableCells/TableCellProductSaleNotice.vue"],"names":[],"mappings":"AAGA,2CACE,YAAA,CACA,kBAAA,CAGF,8BACE,oBAAA,CACA,kBAAA,CACA,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
